import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

const routes = [
  {
    path: "/",
    name: "Domů",
    component: () => import("../views/Marketing.vue")
  },
  {
    path: "/otevrene-hry",
    name: "Otevřené hry",
    component: () => import("../views/OpenGamesDashboard.vue")
  },
  {
    path: "/aktualni-hry",
    name: "Aktuální hry",
    component: () => import("../views/RunningGamesDashboard.vue")
  },
  {
    path: "/akcie",
    name: "Akcie ČR",
    component: () => import("../views/Shares.vue")
  },
  {
    path: "/profil",
    name: "Profil",
    component: () => import("../views/Profile.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/moje-inga",
    name: "Moje INGA",
    component: () => import("../views/MyINGA.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/ukoncene-hry",
    name: "Ukončené hry",
    component: () => import("../views/HistoryGames.vue")
  },
  {
    path: "/top-20",
    name: "Top 20",
    component: () => import("../views/Top20.vue")
  },
  { 
    path: "/bezici-hra/:gid", 
    name: "Běžící hra", 
    component: () => import("../views/RunningGame.vue"),
    meta: { requiresAuth: false },
    props: true
  },
  { 
    path: "/ukoncena-hra/:gid", 
    name: "Ukončená hra", 
    component: () => import("../views/RunningGame.vue"),
    meta: { requiresAuth: false },
    props: true
  },
  {
    path: "/hrac/:uid",
    name: "Detail her hráče",
    component: () => import("../views/UserDetail.vue")
  },
  {
    path: "/forum",
    name: "Fórum",
    component: () => import("../views/Forum.vue")
  },
  {
    path: "/jak-hrat",
    name: "Jak hrát",
    component: () => import("../views/HowToPlay.vue")
  },
  {
    path: "/animator",
    name: "Animátor",
    component: () => import("../views/AnimatorCondition.vue"),
    meta: { requiresAuth: true, requiresAnimator: true }
  },
  {
    path: "/strategie",
    name: "Strategie",
    component: () => import("../views/Strategy.vue")
  },
  {
    path: "/slovnik",
    name: "Slovník pojmů",
    component: () => import("../views/Glossary.vue") 
  },
  {
    path: "/faq",
    name: "FAQ",
    component: () => import("../views/FAQ.vue")
  },
  {
    path: "/media",
    name: "Média",
    component: () => import("../views/Media.vue")
  },
  {
    path: "/about",
    name: "O mně",
    component: () => import("../views/About.vue")
  },
  {
    path: "/dokonceni-registrace",
    name: "Dokončení registrace",
    component: () => import("../views/RegisterConfirmation.vue"),
    // redirect if there aren´t query params token / code
    beforeEnter: (to, from, next) => { 
      if (to.query.token && to.query.code) {
        next();
      } else {
        next('/');
      }
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  if(to.meta.requiresAuth && !store.getters.isLoggedIn) {
    next({path: '/'});
    store.commit('toggleLoginForm');
  } else if (to.meta.requiresAnimator && !store.getters.isAnimator) {
    next({ path: '/' });
  } else next();
})

export default router;
